<template>
  <span>
    <v-tooltip
      v-for="tag in tags"
      :key="`${tag.category}:${tag.value}`"
      :disabled="!allowRemoveChip || tag.isEditable"
      :open-delay="300"
      bottom
    >
      <template #activator="{ on }">
        <v-chip
          :close="allowRemoveChip && tag.isEditable"
          class="ma-1"
          v-on="on"
          @click:close="() => handleDeleteChip(tag)"
        >
          {{ formatTagDisplayName(tag) }}
        </v-chip>
      </template>
      <span>You don't have the permission to remove this tag</span>
    </v-tooltip>
  </span>
</template>

<script setup lang="ts">
import NewTag from '@/models/new_tag'

defineProps<{
  tags: NewTag[]
  allowRemoveChip?: boolean
}>()

const emit = defineEmits(['delete'])

const handleDeleteChip = (tag: string) => {
  emit('delete', tag)
}

const formatTagDisplayName = (tag: NewTag) => {
  return tag.category ? `${tag.category}:${tag.value}` : tag.value
}
</script>
